import { BellAlertIcon } from "@heroicons/react/24/outline";
import { graphql } from "gatsby";
import React, { useEffect } from "react";

export type FooterTx = {
  navigation_name_1: string;
  navigation_name_2: string;
  navigation_name_3: string;
  navigation_name_4: string;
  navigation_name_5: string;
  navigation_name_6: string;
  navigation_name_7: string;
  navigation_name_8: string;
  navigation_href_1: string;
  navigation_href_2: string;
  navigation_href_3: string;
  navigation_href_4: string;
  navigation_href_5: string;
  navigation_href_6: string;
  navigation_href_7: string;
  navigation_href_8: string;
  details: string;
  location: Location;
};

export default function Footer({
  navigation_name_1,
  navigation_name_2,
  navigation_name_3,
  navigation_name_4,
  navigation_name_5,
  navigation_name_6,
  navigation_name_7,
  navigation_name_8,
  navigation_href_1,
  navigation_href_2,
  navigation_href_3,
  navigation_href_4,
  navigation_href_5,
  navigation_href_6,
  navigation_href_7,
  navigation_href_8,
  details,
  location,
}: FooterTx) {
  const navigation = [
    { name: navigation_name_1, href: navigation_href_1 },
    { name: navigation_name_2, href: navigation_href_2 },
    { name: navigation_name_3, href: navigation_href_3 },
    { name: navigation_name_4, href: navigation_href_4 },
    { name: navigation_name_5, href: navigation_href_5 },
    { name: navigation_name_6, href: navigation_href_6 },
    { name: navigation_name_7, href: navigation_href_7 },
    { name: navigation_name_8, href: navigation_href_8 },
  ];

  // add window.location.search
  const [search, setSearch] = React.useState("");
  useEffect(() => {
    setSearch(location.search);
  }, [location.search]);

  return (
    <footer className="relative mt-auto border-t bg-slate-200 shadow-inner">
      <div className="mx-auto max-w-7xl overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
        <nav
          className="-mx-5 -my-2 flex flex-wrap justify-center divide-y text-center sm:divide-y-0 sm:text-left"
          aria-label="Footer"
        >
          {process.env.GATSBY_COUNTRY === "us" && (
            <div className="w-full px-5 py-4 sm:w-auto sm:py-2">
              <a
                href={"/path/1070/1" + search}
                className="text-base text-primary-600 hover:text-primary-900"
              >
                <BellAlertIcon className="h-6 w-6 inline-block mr-2" />
                Job Alerts
              </a>
            </div>
          )}
          {navigation.map(({ name, href }) => (
            <div key={name} className="w-full px-5 py-4 sm:w-auto sm:py-2">
              <a
                href={href}
                className="text-base text-primary-600 hover:text-primary-900"
              >
                {name}
              </a>
            </div>
          ))}
        </nav>
        <p
          className="mx-auto mt-12 text-center text-xs text-gray-600 md:text-sm"
          dangerouslySetInnerHTML={{
            __html: details,
          }}
        ></p>
      </div>
    </footer>
  );
}

export const fragments = graphql`
  fragment Footer on Translations {
    details
    navigation_name_1
    navigation_name_2
    navigation_name_3
    navigation_name_4
    navigation_name_5
    navigation_name_6
    navigation_name_7
    navigation_name_8
    navigation_href_1
    navigation_href_2
    navigation_href_3
    navigation_href_4
    navigation_href_5
    navigation_href_6
    navigation_href_7
    navigation_href_8
  }
`;
